export enum TextAlignment {
  left = 'left',
  center = 'center',
  right = 'right'
}

/** Layout sizes for images: layout.size */
export enum ImageLayoutSize {
  l = 'l',
  m = 'm'
}

/** Layout sizes for videos: layout.size */
export enum VideoLayoutSize {
  l = 'l',
  m = 'm',
  xl = 'xl',
  xxl = 'xxl'
}

/** Used for native header property adMeta: nativeHeader.headerType */
export enum NativeHeaderType {
  iFrame = 'iFrame',
  image = 'image',
  pageStrip = 'pageStrip',
  specialHeadline = 'specialHeadline'
}
